export default __webpack_public_path__ + "static/media/atp_logo.c97419e3.svg";